<template>
  <no-results-games
    v-if="!loading && games && !games.length"
    :text="$t('noResults.gamesNotFound')"
    :image="require('assets/icon/nogame.svg')"
    class="full-width base-border-radius overflow-hidden"
  />
  <div v-else ref="allGames" class="games-list" :style="gamesListStyle">
    <logo-game
      v-for="item in filteredGames"
      :key="item.id"
      :item="item"
      :logo-group="logoGroup"
      :logo-subgroup="logoSubgroup"
      :favorites-games-length="favoritesGamesLength"
      @choose="$emit('choose')"
    />
  </div>
</template>

<script>
import { throttle } from 'src/common/use-events-optimisation'
import LogoGame from 'components/games/LogoGame'
import NoResultsGames from 'components/ui/NoResultsGames.vue'

export default {
  name: 'GamesList',
  components: { NoResultsGames, LogoGame },
  inject: ['mediaQueries'],
  props: {
    games: {
      type: Array,
      default: () => [],
    },
    next: {
      type: [String, Number, Boolean],
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    exclude: {
      type: Array,
      default: () => [],
    },
    logoGroup: {
      type: String,
      default: '',
    },
    logoSubgroup: {
      type: String,
      default: '',
    },
    desktopColumnsCount: {
      type: Number,
      default: 6,
    },
  },
  emits: ['load-more', 'choose'],
  data() {
    return {
      manufacturerList: [],
      competitionGameIds: [],
      fastCashbackGameIds: [],
    }
  },
  computed: {
    favoritesGamesLength() {
      return this.filteredGames.map((item) => item.isFavorite).length - 1
    },
    filteredGames() {
      if (this.exclude) {
        return this.games.filter((g) => !this.exclude.includes(g.id))
      }
      return this.games
    },
    gamesListStyle() {
      return `--columns-count: ${this.desktopColumnsCount}`
    },
  },
  mounted() {
    // Ниже 600 мл лучше не ставить, иначе слишком много запросов
    addEventListener('scroll', throttle(this.checkPosition, 600))
    addEventListener('resize', throttle(this.checkPosition, 800))
  },
  beforeUnmount() {
    removeEventListener('scroll', throttle(this.checkPosition, 600))
    removeEventListener('resize', throttle(this.checkPosition, 800))
  },
  methods: {
    checkPosition() {
      // Нам потребуется знать высоту экрана:
      const screenHeight = window.innerHeight

      // Записываем, сколько пикселей пользователь уже проскроллил:
      const scrolled = window.scrollY

      // Обозначим порог, по приближении к которому
      // будем вызывать какое-то действие.
      const threshold = this.$refs.allGames?.offsetTop + this.$refs.allGames?.offsetHeight

      // Отслеживаем текущую позицию экрана:
      const position = scrolled + screenHeight

      const isLoading = this.next && !this.loading

      if (position >= threshold && isLoading) {
        this.$emit('load-more')
      }
    },
  },
}
</script>

<style lang="scss">
.skeleton {
  padding-top: 8px;
}

.games-list {
  --columns-count: 6;

  position: relative;
  display: grid;
  flex-wrap: wrap;
  gap: 8px;
  grid-template-columns: repeat(2, 1fr);

  @media (min-width: 576px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media (min-width: 768px) {
    grid-template-columns: repeat(4, 1fr);
  }
  @media (min-width: 1200px) {
    grid-template-columns: repeat(var(--columns-count), 1fr);
  }
}
</style>
